import { registerTab } from "lib/@components/tabs"
import { hasDemand } from "lib/authorization/has-demand"
import { MaintenanceLibraryExplorer } from "routes/component-library/explorer/maintenance-library-explorer"

registerTab({
    tab: "sfg20AdminTabs",
    id: "MaintenanceLibrary",
    title: "Maintenance Library",
    content: <MaintenanceLibraryExplorer $lazy />,
    predicate: () => hasDemand("user"),
    priority: 100,
})
